<app-dialog [hideCloseButton]="true">
  <app-dialog-hero>
    <mat-icon
      [class]="'result-dialog__icon result-dialog__icon--' + report.tone"
      aria-hidden="true">
      {{ toneIcon }}
    </mat-icon>
  </app-dialog-hero>
  <app-dialog-title>{{ report.title.key | translate: report.title.params }}</app-dialog-title>
  <app-dialog-content>
    @if (report.message; as message) {
      <p class="result-dialog__message" data-testid="text-result-message">
        {{ message.key | translate: message.params }}
      </p>
    }
    @if (report.sections?.length) {
      <div class="result-dialog__sections">
        @for (section of report.sections; track section.outcome) {
          <section
            [class]="
              'result-dialog__section result-dialog__section--' + outcomeModifiers[section.outcome]
            "
            [attr.data-testid]="'section-result-' + section.outcome">
            <header class="result-dialog__header">
              <h3 class="result-dialog__heading">
                {{ section.heading.key | translate: section.heading.params }}
              </h3>
              @if (showCounts && section.items.length > 1) {
                <span class="result-dialog__count">{{ section.items.length }}</span>
              }
            </header>
            <ul class="result-dialog__items">
              @for (item of section.items; track $index) {
                <li class="result-dialog__item">
                  <span class="result-dialog__row">
                    <span class="result-dialog__who">
                      <span class="result-dialog__label">{{ item.label }}</span>
                      @if (item.sublabel) {
                        <span class="result-dialog__sublabel">{{ item.sublabel }}</span>
                      }
                    </span>
                    @if (item.aside; as aside) {
                      <span
                        class="result-dialog__aside"
                        [class.result-dialog__aside--problem]="aside.isProblem">
                        {{ aside.text.key | translate: aside.text.params }}
                      </span>
                    }
                  </span>
                  @if (item.details?.length) {
                    <span class="result-dialog__details">
                      @for (detail of item.details; track detail.key) {
                        <span class="result-dialog__detail">{{
                          detail.key | translate: detail.params
                        }}</span>
                      }
                    </span>
                  }
                </li>
              }
            </ul>
          </section>
        }
      </div>
    }
  </app-dialog-content>
  <app-dialog-actions class="result-dialog__actions">
    @if (report.secondaryAction; as secondary) {
      <button
        type="button"
        matButton
        class="result-dialog__secondary"
        [mat-dialog-close]="secondaryChoice"
        data-testid="btn-result-dialog-secondary">
        {{ secondary.key | translate: secondary.params }}
      </button>
    }
    <button type="button" matButton="filled" mat-dialog-close data-testid="btn-close-result-dialog">
      {{ closeKey | translate }}
    </button>
  </app-dialog-actions>
</app-dialog>
